<!-- Monitoring Details Counters Template -->
<div class="w-full">
  <div
    class="grid grid-cols-1 md:grid-cols-4 gap-6 w-full"
    style="grid-auto-rows: 1fr;"
  >
    <ape-status-card
      *ngFor="let item of monitoringDetailsCountersCardData; trackBy: trackCardByIndex"
      [variant]="'gray'"
      [cardData]="item"
      [cssClass]="'overflow-auto'"
      class="w-full h-full"
    />
  </div>
</div>